import React from "react";
import { forgotOne } from "../../actions/user";
import { tempAlWait } from "../../helpers";
import { connect } from "react-redux";

class ForgotPwdOne extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        form: {
            email: ''
        },
        emailFocus: false
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.alert != prevState.alert) {
            this.props.changeAlert(this.state.alert);
        }

        if (this.props.redFgtPwdOne != prevProps.redFgtPwdOne) {
            this.setState({
                alert: this.props.redFgtPwdOne.alert
            })
            if (this.props.redFgtPwdOne.isNext) {
                this.props.changeStep("forgot-two");
                this.props.changeEmailForgot(this.state.form.email);
            }
        }
    }

    handleForgot = (el) => {
        el.preventDefault();
        this.props.forgotOne({
            email: this.state.form.email
        });
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <div className={`signin ${this.props.otherClass != null && `signin--${this.props.otherClass}`}`}>
            <h2 className="signin__ttl">Mot de passe oublié</h2>
            <form className="signin__form">
                <p className="signin__help signin__help--noitalic">Vous recevrez un code sur votre boîte mail. Après avoir cliquer sur "Recevoir mon code", vérifiez dans vos spams.</p>
                <p className="signin__help">* champs obligatoires</p>
                {/** Email **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir votre adresse e-mail"
                    aria-label="Assurez-vous de saisir votre adresse e-mail"
                >
                    <label
                        htmlFor="forgot-one-email"
                        className={`signin__lab ${(this.state.emailFocus || this.state.form.email != '') && 'signin__lab--reduce'}`}
                    >
                        E-mail *
                    </label>
                    <input
                        type="email"
                        className="signin__inp"
                        id="forgot-one-email"
                        required
                        value={this.state.form.email}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    email: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({emailFocus: true})}
                        onBlur={() => this.setState({emailFocus: false})}
                    />
                </div>
                {/** Bouton validation **/}
                <button
                    title="Recevoir mon code"
                    aria-label="Recevoir mon code"
                    className="signin__btn"
                    type="button"
                    onClick={(el) => this.handleForgot(el)}
                >
                    Recevoir mon code
                </button>
            </form>
            {/** Footer **/}
            <footer className="signin__ftr">
                <button
                    title="Je me souviens de mon mot de passe"
                    aria-label="Je me souviens de mon mot de passe"
                    className="signin__link"
                    onClick={() => this.props.changeStep("signin")}
                >
                    Se connecter
                </button>
                <button
                    title="Pas encore de compte ?"
                    aria-label="Pas encore de compte ?"
                    className="signin__link"
                    onClick={() => this.props.changeStep("signup")}
                >
                    Créer un compte
                </button>
            </footer>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redFgtPwdOne: state.redFgtPwdOne
    }
}

const mapDispatchToProps = {
    forgotOne
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPwdOne);